"use client";

import { Divider, Text } from "@stone-payments/jade";
import { type Product } from "@/actions/schemas/products";
import { ProductCard } from "@/components/product-card";
import { useStore } from "@/contexts/store";
import { Skeleton } from "@/components/skeleton";
import { productAnalitica } from "@/app/(store)/_utils/events";

type ProductsRelatedProps = {
  loading: boolean;
  products?: Product[];
};

const ProductsRelatedLoading = () => {
  return (
    <div className="py-3 md:py-5 xl:py-8">
      <div className="rounded-jade-xlarge border-(--theme-color-border-low) md:border md:p-5">
        <div className="mb-5">
          <div className="py-2">
            <Skeleton className="h-5! w-35!" rounded={true} />
          </div>

          <div className="md:hidden">
            <Divider />
          </div>
        </div>

        <div className="grid grid-cols-2 items-start gap-x-8 gap-y-7 md:grid-cols-4 xl:grid-cols-6">
          {Array.from({ length: 6 }).map((_, index) => (
            <ProductCard loading={true} layout="grid" key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

const ProductsRelatedComponent = ({
  products,
}: Pick<ProductsRelatedProps, "products">) => {
  const { store } = useStore();

  if (products?.length === 0) {
    return null;
  }

  return (
    <section className="py-3 md:py-5 xl:py-8">
      <div className="rounded-jade-xlarge border-(--theme-color-border-low) md:border md:p-5">
        <div className="mb-5">
          <Text className="py-2!" as="h3" variant="heading-xsmall">
            Você também pode gostar
          </Text>

          <div className="md:hidden">
            <Divider />
          </div>
        </div>

        <div className="grid grid-cols-2 items-stretch gap-5 md:grid-cols-4 md:gap-3 xl:grid-cols-6 xl:gap-5">
          {products?.slice(0, 6).map((product) => (
            <ProductCard
              data={product}
              layout="grid"
              store={store}
              key={product.id}
              onClick={() => productAnalitica.events.action.relatedClicked()}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const ProductsRelated = ({ loading, products }: ProductsRelatedProps) => {
  if (loading) {
    return <ProductsRelatedLoading />;
  }

  return <ProductsRelatedComponent products={products} />;
};

export { ProductsRelated, type ProductsRelatedProps };
